<script lang="ts" setup>
  const attrs = useAttrs();
</script>

<template>
  <NuxtImg v-bind="attrs" loading="lazy" decoding="auto" :ismap="false" />
</template>
